import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CandidateBuilder,
  UpdateCandidatePositionHighlightInput,
  UpdateCandidatePositionHighlightOutput,
} from '../candidates.types';

export const updateCandidatePositionHighlight = (builder: CandidateBuilder) =>
  builder.mutation<
    UpdateCandidatePositionHighlightOutput,
    UpdateCandidatePositionHighlightInput
  >({
    query: (args) => ({
      url: `/candidate-position-status/highlight`,
      method: 'PATCH',
      body: args,
      responseHandler: (response) => response.text(),
    }),
    transformResponse: (res, meta, args) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.UPDATE_CANDIDATE_HIGHLIGHT
          : SuccessMessageEn.UPDATE_CANDIDATE_HIGHLIGHT,
        true
      );
      return args;
    },
    transformErrorResponse: (err) => {
      errorHandler(
        '[updateCandidatePositionHighlight]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.CanditatePositionStatusError
          : ErrorMessageEn.CanditatePositionStatusError,
        err,
        true
      );
      return err.data;
    },
  });
